// this entry point requires the following peer dependencies: @wix/dashboard
export { WixPatternsProvider } from '../../dashboard/WixPatternsProvider';
export { WixPatternsProviderProps } from '../../dashboard/WixPatternsDashboardBaseProvider';
